import { usePage } from '@inertiajs/react';
import useValuationAutosave from './useValuationAutosave';

const useValuationStepAutosave = <T extends object>(
	step: string,
	valuationId: number | null | undefined,
	data: T
) => {
	const { readOnly } = usePage<any>().props;
	return useValuationAutosave({
		url: valuationId ? `/valuation-form/${valuationId}/${step}` : null,
		data,
		enabled: !readOnly,
	});
};

export default useValuationStepAutosave;
